/**
 * Eddie Borgo — Image zoom + pan on hover
 *
 * 1. Normal: image at 100%, looks normal
 * 2. Hover: image scales up (zoom in)
 * 3. Mouse moves: zoomed image pans to follow cursor
 * 4. Mouse leaves: smoothly zooms back to normal
 *
 * Article page: heavy zoom (2.5x) for reading detail
 * Blog listing: subtle zoom (1.2x) for browsing
 *
 * Container overflow:hidden clips the zoomed/panned image.
 * Uses event delegation + MutationObserver for HMR compatibility.
 */
(function () {
  'use strict';

  var BLOG_SCALE = 1.2;
  var BLOG_PAN = 8;
  var ARTICLE_SCALE = 2.5;
  var ARTICLE_PAN = 25;
  var TRANSITION = 'transform 0.2s ease-out';

  function getParams(wrap) {
    var isArticle = !!wrap.closest('.template-article');
    var scale = isArticle ? ARTICLE_SCALE : BLOG_SCALE;
    // Pan range = how far the image can translate to reveal edges
    // At scale S, image is S times wider. To reach the edge:
    // pan = (S - 1) / S * 50  (as percentage of image size)
    var pan = (scale - 1) / scale * 50;
    return { scale: scale, pan: pan };
  }

  function wrapImages() {
    var selectors = '.eb-blog-card__content img, .eb-article-wrapper .article-image img, .template-article .article-rte img';
    var images = document.querySelectorAll(selectors);
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (img.parentElement && img.parentElement.classList.contains('eb-pan-wrap')) continue;
      var wrap = document.createElement('span');
      wrap.className = 'eb-pan-wrap';
      wrap.style.display = 'inline-block';
      wrap.style.overflow = 'hidden';
      wrap.style.position = 'relative';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
      img.style.transition = TRANSITION;
      img.style.pointerEvents = 'none';
    }
  }

  document.addEventListener('mouseenter', function (e) {
    var wrap = e.target.closest ? e.target.closest('.eb-pan-wrap') : null;
    if (!wrap) return;
    var img = wrap.querySelector('img');
    if (!img) return;
    var p = getParams(wrap);
    img.style.transition = TRANSITION;
    img.style.transform = 'scale(' + p.scale + ')';
  }, true);

  document.addEventListener('mousemove', function (e) {
    var wrap = e.target.closest ? e.target.closest('.eb-pan-wrap') : null;
    if (!wrap) return;
    var img = wrap.querySelector('img');
    if (!img) return;
    var p = getParams(wrap);

    var rect = wrap.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width;
    var y = (e.clientY - rect.top) / rect.height;
    var tx = (0.5 - x) * p.pan * 2;
    var ty = (0.5 - y) * p.pan * 2;

    img.style.transition = 'transform 0.15s ease-out';
    img.style.transform = 'scale(' + p.scale + ') translate(' + tx + '%, ' + ty + '%)';
  }, { passive: true });

  document.addEventListener('mouseleave', function (e) {
    var wrap = e.target.closest ? e.target.closest('.eb-pan-wrap') : null;
    if (!wrap) return;
    var img = wrap.querySelector('img');
    if (!img) return;
    img.style.transition = 'transform 0.25s ease-out';
    img.style.transform = 'scale(1) translate(0, 0)';
  }, true);

  function init() {
    wrapImages();
    new MutationObserver(function () { wrapImages(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
